import { css } from 'styled-components';
import { isDesktopListSelector, isDesktopMapSelector } from '@/app/common/css/selectors.ts';

export const showOnlyOnDesktopInSearchPage = css`
  ${isDesktopListSelector} &,
    ${isDesktopMapSelector} & {
    @media (max-width: 1023px) {
      display: none;
    }
  }
`;

export const showOnlyOnDesktopMapInSearchPage = css`
  ${isDesktopMapSelector} & {
    @media (max-width: 1023px) {
      display: none;
    }
  }
`;
